module.exports = __webpack_public_path__ + "img/egypt.cbf1c0e.webp";